export const Constants = {
  Steps: [
    {
      selector: "step_1",
      classToAdd: "nothingclass",
      title: "Measures",
      content:
        "This is a collection of measures of psychological processes, many of which could plausibly be mechanisms through which interversions exert their effects",
      right: "unset",
      top: "2vh",
      left: "0vh",
      mobileTop: "25%"
    },
    {
      selector: "step_2",
      classToAdd: "nothingclass",
      title: "Interventions",
      content:
        "This is a collection of procedures designed to change people's psychology and behavior",
      right: "unset",
      top: "2vh",
      left: "0vh",
      mobileTop: "25%"
    },
    {
      selector: "step_3",
      classToAdd: "nothingclass",
      title: "Behaviors",
      content: "This is a collection of indicators of behavior",
      right: "unset",
      top: "2vh",
      left: "0vh",
      mobileTop: "25%"
    },

    {
      selector: "search_itm",
      classToAdd: "nothingclass",
      title: "Search",
      content:
        "Use this textbox to find a particular measure, intervention, or behavior, depending on the collection you are searching",
      right: "unset",
      top: "3.5vh",
      left: "null",
      mobileTop: "32%"
    },

    {
      selector: "cont_test",
      classToAdd: "nothingclass",
      title: "Filter",
      content:
        "When searching, explore and filter to particular subsets of measures, interventions or behaviors",
      right: "unset",
      top: "15vh",
      left: "41vh",
      mobileTop: "70%"
    },

    {
      selector: "add-measure-btn",
      classToAdd: "nothingclass",
      title: "Add",
      content:
        "If you have created a user account, you can add or edit existing measures, interventions and behaviors to further enhance the repository",
      right: "unset",
      top: "4vh",
      left: "0vh",
      mobileTop: "40%"
    },
    {
      selector: "down_arrow_icon",
      classToAdd: "measuretag",
      title: "Details",
      content:
        "This textbox provides background on the framework that informed the development of the repository, the experimental medicine approach to behavior change. Click the chevron to hide the textbox",
      right: "unset",
      top: "null",
      left: "-4.5vh",
      mobileTop: "53%"
    },
    {
      selector: "mez_tag_2",
      classToAdd: "nothingclass",
      title: "Tags",
      content:
        "View at a glance the characteristics of this measure, intervention or behavior",
      right: "unset",
      top: "0",
      left: "-1vh",
    },
    {
      selector: "mez_img",
      classToAdd: "measuretag",
      title: "Source and Integrations",
      content:
        "See at a glance the database or collection this measure, intervention or behavior comes from as well as the other projects or features that are built for this measure, intervention or behavior",
      right: "unset",
      top: "8px",
      left: "-4.5vh",
    },
    {
      selector: "null",
      classToAdd: "nothingclass",
      title: "Complete",
      content:
        "Congratulations! Youve completed the onboarding tour. Feel fre to access this walkthrough again anytime at the top of the menu bar on the homepage",
      right: "unset",
      top: "4vh",
    },
  ],
  NullStep: {
    stepCount: -1,
    selector: null,
    classToAdd: null,
    title: "",
    content: "",
    right: "unset",
    top: "unset",
    left: "0vh",
  },
  OverlayId: "tourOverlay",
  ButtonLabels: {
    Skip: "Skip",
    End: "End",
    Next: "Next",
  },
};
